import React from 'react';
import {
  FormControl, FormLabel, Input, Tab, TabList, TabPanel, TabPanels, Tabs, Textarea,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const LOCALES = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'sw', label: 'Kiswahili' },
];

export const emptyLocalized = () => ({ en: '', fr: '', sw: '' });

export const toLocalized = (value) => {
  if (!value) return emptyLocalized();
  if (typeof value === 'string') return { en: value, fr: value, sw: value };
  return {
    en: value.en || '',
    fr: value.fr || '',
    sw: value.sw || '',
  };
};

const LocalizedFields = ({ value, onChange }) => {
  const { t } = useTranslation();

  const setField = (field, locale, text) => {
    onChange({
      ...value,
      [field]: { ...toLocalized(value[field]), [locale]: text },
    });
  };

  return (
    <Tabs variant="enclosed" colorScheme="brand" size="sm" mb={5} isLazy>
      <TabList>
        {LOCALES.map((locale) => (
          <Tab key={locale.code} fontWeight="600">{locale.label}</Tab>
        ))}
      </TabList>
      <TabPanels>
        {LOCALES.map((locale) => (
          <TabPanel key={locale.code} px={0} pt={4}>
            <FormControl mb={5} isRequired>
              <FormLabel fontWeight="600">{t('admin.itemTitle')}</FormLabel>
              <Input
                value={toLocalized(value.title)[locale.code]}
                onChange={(e) => setField('title', locale.code, e.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontWeight="600">{t('admin.description')}</FormLabel>
              <Textarea
                rows={4}
                value={toLocalized(value.description)[locale.code]}
                onChange={(e) => setField('description', locale.code, e.target.value)}
              />
            </FormControl>
          </TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};

export default LocalizedFields;
